module.exports = __webpack_public_path__ + "site/img/148.0003ec10.jpg";